<template>
  <div class="media">
    <div class="video" v-if="type == 'video'">
      <img class="bg" :src="src">
       <svg-icon v-if="!status" icon-class="linear-play" class="svg_img" />
    </div>
    <div class="audio" v-else-if="type == 'audio'">
      <img class="bg" :src="src">
      <img
        class="audio_icon"
        src="../../../assets/question/yp.png"
        v-if="!status"
      />
    </div>
    <div class="image" v-else-if="type == 'image'"><img :src="src"></div>
    <div v-else>暂无类型</div>
    <div class="media_time">
      {{duration}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    src: {
      type:String,
      default:require("../../../assets/question/spsf_sample.png")
    },
    duration:{
      type:String,
      default:' 01:10'
    },
  },
  data: () => ({
    status: false,
  }),
  methods: {
    play() {
      this.status = true;
      this.$refs.media.play();
    },
  },
};
</script>

<style lang="scss" scope>
.media {
  width: 100%;
  height: 100%;
  position: relative;
  .video {
    width: 100%;
    height: 100%;
    .bg{
      width: 100%;
      height: 100%;
    }
  .svg_img{
    color: #A2A2A2;
    font-size: 62px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
    
  }
  .audio {
    width: 100%;
    height: 100%;
    .bg{
      width: 100%;
      height: 100%;
    }
    
  .audio_icon {
    width: 31px;
    height: 31px;
    position: absolute;
    top: 10%;
    right: 10%;
    cursor: pointer;
  }
    
  }

  .media_time{
    color: #fff;
    font-size: 12px;
    position: absolute;
    bottom: 6%;
    right: 6%;
    padding: 0 14px;
    height: 24px;
    line-height: 24px;
    background: rgba($color: #000, $alpha:0.3);
    border-radius: 50px;
  }
}
</style>